import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// routes
import { CURD_L1_MENU } from "../../../../utils/routes";

// ---------------------------------------------------------------------

export const createL1Menu = createAsyncThunk(
  "l1Menu/createL1Menu",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(CURD_L1_MENU, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getL1Menu = createAsyncThunk(
  "l1Menu/getL1Menu",
  async (obj, {rejectWithValue}) => {
    try {
      const response = await axios.get(CURD_L1_MENU, { withCredentials: true });
      return response;
    } catch (err) {
      return rejectWithValue(err.response)
    }
  }
);

export const updateL1Menu = createAsyncThunk(
  "l1Menu/updateL1Menu",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(CURD_L1_MENU, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteL1Menu = createAsyncThunk(
  "l1Menu/deleteL1Menu",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.delete(CURD_L1_MENU, {
        data,
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const l1MenuSlice = createSlice({
  name: "l1Menu",
  initialState: {
    loading: false,
    message: "",
    errMessage: "",
    l1MenuData: [],
    l1SelectedData: {},
  },
  reducers: {
    resetMessage: (state) => {
      state.message = "";
    },
    resetErrMessage: (state) => {
      state.errMessage = "";
    },
    rowSelect: (state, action) => {
      state.l1SelectedData = action?.payload.length > 0 && action?.payload[0];
    },
  },
  extraReducers: {
    [createL1Menu.pending]: (state, action) => {
      state.loading = true;
    },
    [createL1Menu.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [createL1Menu.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [getL1Menu.pending]: (state, action) => {
      state.loading = true;
    },
    [getL1Menu.fulfilled]: (state, action) => {
      state.loading = false;
      state.l1MenuData = action?.payload?.data;
    },
    [getL1Menu.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },
    [updateL1Menu.pending]: (state, action) => {
      state.loading = true;
    },
    [updateL1Menu.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [updateL1Menu.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [deleteL1Menu.pending]: (state, action) => {
      state.loading = true;
    },
    [deleteL1Menu.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [deleteL1Menu.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
  },
});

export const { resetMessage, resetErrMessage, rowSelect } =
  l1MenuSlice.actions;
export default l1MenuSlice.reducer;
